import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalUpdateStatusChat",
  tabindex: "-1",
  "aria-labelledby": "chatModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteChat"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { USER_POST_STORE } from '@/store/constants'
import { ChatStateTypes } from '@/store/modules/chat'
import { computed, ComputedRef } from 'vue-demi'
import { useStore } from 'vuex'
import { watch, ref } from 'vue'
import { UpdateStatusMessage } from '@/services/user-post.services'
import { ERROR_STATUS_HAS_CHANGED } from '@/constants/index'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const title = ref(translate('publicTalk'))
const store = useStore()

const comment = computed<ComputedRef<Pick<ChatStateTypes, 'comment'>>>(() => store.getters[USER_POST_STORE.GETTERS.GET_COMMENT])

const updateStatus = async (): Promise<void> => {
  const payload: UpdateStatusMessage = {
    post_id: comment.value.post_id,
    comment_id: comment.value.id,
    published: !comment.value.published,
  }

  const isUpdate = await store.dispatch(USER_POST_STORE.ACTIONS.UPDATE_STATUS_COMMENT, payload)
  if (!isUpdate.success && isUpdate.message_code === ERROR_STATUS_HAS_CHANGED) {
    // FIXME: ここでエラーモダールを表示する
  }
}

watch(
  () => comment.value?.published,
  () => {
    if (comment.value.published) {
      title.value = translate('privateTalk')
    } else {
      title.value = translate('publicTalk')
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(title.value), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Button, {
            title: _unref(translate)('cancel'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            class: "me-2",
            "data-bs-Toggle": "modal",
            "data-bs-target": "#modalPost"
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: 'OK',
            dataBsTarget: title.value === _unref(translate)('publicTalk') ? '#updatePublicSuccess' : '#updatePrivateSuccess',
            dataBsToggle: 'modal',
            onClick: updateStatus
          }, null, 8, ["dataBsTarget"])
        ])
      ])
    ])
  ]))
}
}

})